import { PropsWithChildren } from 'react';
import { useFormContext } from 'react-hook-form';
import { cx } from '@emotion/css';

import { HookFormRadioProps } from './hook-form-radio.types';
import { useTranslation } from 'next-i18next';
import { Hint, HintType } from '@phoenix/design-system/frontend/ui/form/hint';

export const HookFormRadio = ({
  name,
  className,
  classNameLabel,
  description,
  disabled,
  required = false,
  withinRadioGroup = false,
  label,
  id,
  value,
  autoComplete = 'on',
  labelClassName,
  ...restProps
}: PropsWithChildren<HookFormRadioProps>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation('shared');

  // FIXME: how to handle the issue with the name prop of not being passed down in a radio group form via the child but being passed down via the parent?
  const hint = errors[name as string]?.message && {
    message: errors[name as string]?.message,
    type: 'error' as HintType,
  };

  return (
    <div className={cx('mb-2 lg:mb-m', className)} {...restProps} data-testid={value}>
      <label htmlFor={id} className={cx('relative', labelClassName)} style={{ left: '4px' }}>
        <input {...register(name as string)} id={id} type="radio" value={value} disabled={disabled} autoComplete={autoComplete} />
        {typeof label === 'string' && (
          <span
            className={cx('relative ml-s stihl-text-body-sm-reg', classNameLabel)}
            style={{ top: '1px' }}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: `${label} ${!required ? t('shared_formControlLabel_optionalSuffix') : ''}`,
            }}
          />
        )}
        {label && typeof label === 'object' && label}
      </label>
      {description && <div className="mt-1 stihl-text-body-xs-reg">{description}</div>}
      {!withinRadioGroup && hint && <Hint {...hint} />}
    </div>
  );
};
